import { useMemo } from 'react';
import { useSelector } from 'react-redux';

const useBusinessChatUnread = () => {
    const { userData } = useSelector((state) => state.user);
    const { allChats } = useSelector((state) => state.chat);

    const unreadCount = useMemo(() => {
        if (!userData?.id || !allChats || !allChats.length) {
            return 0;
        }

        let totalUnread = 0;
        allChats.forEach((chat) => {
            totalUnread += Number(chat[userData.id]) || 0;
        });

        return totalUnread;
    }, [userData?.id, allChats]);

    return unreadCount;
};

export default useBusinessChatUnread;
